export default {
    url: '/question/:id',
    template: `
    <forms-questions-all-question
        form="vm.form"
        sites="vm.sites"
        question-pools="vm.questionPools"
        meta-field-groups="vm.metaFieldGroups"
        question="vm.question">
    </forms-questions-all-question>`,
    resolve: {
        sites: (SiteResource) => {
            return SiteResource.query({
                formSites: true,
                fields: 'id,name',
                pageSize: 0
            }).$promise;
        },
        question (QuestionResource, $stateParams) {
            return QuestionResource.get({
                id: $stateParams.id,
                expand: 'questionI18ns,pool,category,author,questionAnswers,questionMeta,tags,metaGroups,questionAnswersI18ns,questionMetaFields,childQuestionsActiveI18ns,childQuestions,forms,sites'
            }).$promise;
        },
        questionPools (QuestionPoolResource, FORMS_POOL_ENUM) {
            return QuestionPoolResource.query({ status: FORMS_POOL_ENUM.KEYS.ACTIVE, pageSize: 0 }).$promise;
        },
        metaFieldGroups (MetaFieldGroupResource) {
            return MetaFieldGroupResource.query({ pageSize: 0 }).$promise;
        }
    },
    controller (sites, question, metaFieldGroups, questionPools, FormFactory) {
        this.sites = sites;
        this.question = question;
        this.metaFieldGroups = metaFieldGroups;
        this.questionPools = questionPools;
        this.form = FormFactory.createFromResource(this.question, {
            expand: 'questionI18ns,pool,category,author,questionAnswers,questionMeta,tags,metaGroups,questionAnswersI18ns,questionMetaFields,childQuestionsActiveI18ns,childQuestions,forms,sites'
        });
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/forms/questions/all/question/index.js